<template src="./html/Edit.html"></template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'
	import EditContent from './EditContent.vue'
	import Images from './Images.vue'
	import Treeselect from '@riophae/vue-treeselect'

	export default {
		props: ['user', 'isAuth', 'item'],
		components: {
			'edit-content': EditContent,
			'treeselect': Treeselect,
			'images': Images,
		},
		data () {
			return {
				modal: {
					selector: 'modal-edit-product-' + Math.floor(Math.random() * 736456),
				},
				product: null,
				categoriesWithProducts: null,

				group: [],

				product_id: null,

				id: null,

				error: false,
			}
		},
		created() {
			this.init()
		},
		mounted() {
			var that = this
			$('#' + this.modal.selector).on('hidden.bs.modal', function (event) {
				if ($('.modal:visible').length) {
					$('body').addClass('modal-open')
				}
			})

			$.fn.modal.Constructor.prototype.enforceFocus = function () {};
			$('#' + this.modal.selector).on('shown.bs.modal', function (event) {
				event.stopPropagation()
				var input = $('#tbody-attribute-storages').find('input[type=text],input[type=number],select').filter(':input:visible:first')
				input.focus()
			})
		},
		methods: {
			reload() {
				this.$emit('reload')
			},
			init() {
				this.getCategoriesAndProducts()
			},
			open(product, id = null) {
				this.product = JSON.parse(JSON.stringify(product))
				var modal = $('#'+this.modal.selector)
				this.id = id
				this.$nextTick( () => {
					modal.modal('show')
				})
			},
			close () {
				this.product = null
				var modal = $('#'+this.modal.selector)
				modal.modal('hide')
			},
			getCategoriesAndProducts: function() {
				this.$http.get('admin/management/products/categories/products')
					.then(response => {
						this.categoriesWithProducts = response.body
					})
			},
			hasErrors(error) {
				this.error = error
			},
			validate(event) {
				event.stopPropagation()
				if(!this.error) {
					var that = this
					return this.$validator.validateAll().then((result) => {
						if(result) {
							that.update()
						}
						return result
					})
				}
			},
			update (alert = true) {
				var that = this
				var loading = Ladda.create(this.$refs.btnUpdate)
				loading.start()
				this.$http.put('admin/management/products/storages/' + this.product.id, this.product)
				.then(response => {
					loading.stop()
					this.$emit('reload')
					if(alert) {
						swal({
							title: response.body.title,
							text: response.body.text,
							type: response.body.type
						})
					}
					this.close()
				}).catch(function(response) {
					console.log(response)
					loading.stop()
					this.$emit('reload')
				})
			},
			normalizer(node) {
				if(node.children) {
					var id = 'category-' + node.id
				} else {
					var id = node.id
				}
				return {
					id: id,
					label: node.title,
					children: node.children,
				}
			},
			addGroupProduct(group) {
				var data = {
					product_id: group.selected,
					product_storage_id: this.product.id,
					budget_id: this.product.budget_id,
					order_id: this.product.order_id,
					invoice_id: this.product.invoice_id,
					order_provider_id: this.product.order_provider_id,
					invoice_provider_id: this.product.invoice_provider_id,
				}

				this.storeGroupProduct(data)
			},
			newGroupProduct() {
				var data = {
					product_id: this.product_id,
					product_storage_id: this.product.id,
					budget_id: this.product.budget_id,
					order_id: this.product.order_id,
					invoice_id: this.product.invoice_id,
					order_provider_id: this.product.order_provider_id,
					invoice_provider_id: this.product.invoice_provider_id,
				}

				this.product_id = null

				this.storeGroupProduct(data)
			},
			storeGroupProduct(data, group = null) {
				var that = this

				swal.queue([{
					title: that.$t("messages.attention"),
					text: "Se añadirá un producto",
					type: "warning",
					showCancelButton: true,
					confirmButtonColor: "#53e69d",
					cancelButtonColor: "#ff7676",
					confirmButtonText: "Si",
					cancelButtonText: "No",
					showLoaderOnConfirm: true,
					preConfirm: function () {
						return new Promise(function (resolve) {
							//-- Update product
							that.$http.put('admin/management/products/storages/' + that.product.id, that.product)
							.then(response => {
								//-- Store group product
								that.$http.post('admin/management/products/groups/storage', data)
								.then(response => {
									if(group) {
										group.selected = null
									}
									var product = response.body.data
									if(that.product) {
										if(!that.product.products) {
											that.$set(that.product, 'products', [])
										}
									}
									that.product.products.push(product)
									that.$emit('reload')
									swal(response.body.title, response.body.text, response.body.type);
								}).catch(function(response) {
									console.log(response)
									if(response.status == 409) {
										swal(response.body.title, response.body.text, response.body.type);
									} else {
										swal({
											title: response.statusText,
											text: response.body,
											type: "warning"
										});
									}
								})
							}).catch(function(response) {
								console.log(response)
								this.$emit('reload')
							})
						})
					}
				}]).catch(swal.noop)
			},
			resetValuesInherit(attribute) {
				var product_attribute_list_id = attribute.product_attribute_list_id
				if(this.product) {
					if(this.product.attribute_storages) {
						if(this.product.attribute_storages.length){
							var that = this
							this.product.attribute_storages.forEach(function(attribute) {
								if(attribute.product_attribute_list_id == product_attribute_list_id) {
									that.$refs.content.inherit(attribute)
								}
							})
						}
					}
				}
			},
			active(product) {
				var active = ''
				if(this.id) {
					if(this.id == product.id) {
						active = 'active'
					}
				}
				return active
			}
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/management/productStorages/views/Edit.vue